const HolidayHours = () => {
  return <div>Holiday Hours</div>;
};

export default HolidayHours;
